import * as React from "react";
import type { SVGProps } from "react";
const TiktokBlack = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={21}
    height={24}
    fill="none"
    viewBox="0 0 21 24"
    {...props}
  >
    <g clipPath="url(#clip0_162_251)">
      <path
        fill="currentColor"
        d="M21.0236 9.839a9.86 9.86 0 0 1-5.7562-1.8374v8.3765a7.605 7.605 0 0 1-1.3594 4.3407 7.63 7.63 0 0 1-3.5906 2.7937c-1.4531.5438-3.0375.6328-4.5422.2484a7.673 7.673 0 0 1-3.8766-2.3812C.8767 20.2125.244 18.7547.0705 17.2125s.136-3.0984.8719-4.4625 1.875-2.4703 3.2625-3.1734 2.9484-.961 4.486-.75v4.214c-.7032-.2203-1.4579-.2156-2.1563.0188a3.51 3.51 0 0 0-1.7344 1.2797c-.4266.5953-.6563 1.3171-.6516 2.0578s.2438 1.4531.6797 2.0484a3.49 3.49 0 0 0 1.7531 1.2609c.7032.225 1.4578.225 2.1563-.0046s1.3125-.675 1.7437-1.2703a3.51 3.51 0 0 0 .6657-2.0532V0h4.125c-.0047.3469.0281.6984.089 1.0406.1453.764.4406 1.4953.8766 2.1422.4359.6469.9984 1.2 1.65 1.6219a5.714 5.714 0 0 0 3.1406.9422v4.0969z"
      />
    </g>
    <defs>
      <clipPath id="clip0_162_251">
        <path fill="transparent" d="M0 0h21v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default TiktokBlack;
